import { render, staticRenderFns } from "./ActivePeriodTable.vue?vue&type=template&id=1203a8a0&scoped=true&"
import script from "./ActivePeriodTable.vue?vue&type=script&lang=js&"
export * from "./ActivePeriodTable.vue?vue&type=script&lang=js&"
import style0 from "./ActivePeriodTable.vue?vue&type=style&index=0&id=1203a8a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1203a8a0",
  null
  
)

export default component.exports